module.exports = __webpack_public_path__ + "static/media/page3-goats.9055679e.png";